"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModes = exports.DataItemTypes = void 0;
var DataItemTypes;
(function (DataItemTypes) {
    DataItemTypes["SINGLE_WIDGET"] = "single-widget";
    DataItemTypes["WIDGET_BUNDLE"] = "widget-bundle";
    DataItemTypes["WIDGET_ITEM"] = "widget-item";
})(DataItemTypes = exports.DataItemTypes || (exports.DataItemTypes = {}));
var ViewModes;
(function (ViewModes) {
    ViewModes["NAVIGATION"] = "navigation";
    ViewModes["SEARCH_ITEMS"] = "searchItems";
    ViewModes["SEARCH_WIDGETS"] = "searchWidgets";
    ViewModes["EDIT"] = "edit";
})(ViewModes = exports.ViewModes || (exports.ViewModes = {}));
